import script from "./NewFlight.vue?vue&type=script&setup=true&lang=js"
export * from "./NewFlight.vue?vue&type=script&setup=true&lang=js"

import "./NewFlight.vue?vue&type=style&index=0&id=167976a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-167976a6"]])

export default __exports__